module.exports = __webpack_public_path__ + "db841fafef00704584826652956b6add.png";